import { useCallback, useState } from "react";
import { PublishScriptDocument, PublishScriptUpdate } from "generated/graphql";
import { runGqlMutation } from "gqlClient";
import { PublishModal } from "routes/lens-editor/PublishModal";

interface PublishScriptModalProps {
  lensId: number;
  scriptName: string;
  open: boolean;
  close: () => void;
}

const PublishScriptModal = (props: PublishScriptModalProps) => {
  const { lensId, scriptName } = props;
  const [updateInfo, setUpdateInfo] = useState<PublishScriptUpdate[]>([]);
  const [dryrun, setDryrun] = useState(true);
  const [error, setError] = useState("");
  const [disabled, setDisabled] = useState(false);

  const handlePublishScript = async (dryrun: boolean, onlyPublishLensIds: number[]) => {
    setDisabled(true);
    setDryrun(dryrun);
    return runGqlMutation(PublishScriptDocument, { lensId, scriptName, dryrun, onlyPublishLensIds })
      .then((response) => {
        setUpdateInfo(response.lens.scripts.publishScript.updateInfo);
        setError("");
        setDisabled(false);
      })
      .catch((e) => {
        setError(e.message);
        setDisabled(false);
      });
  };

  const dryrunOnMount = useCallback(() => {
    handlePublishScript(true, []);
  }, []);

  return (
    <PublishModal
      ref={dryrunOnMount}
      open={props.open}
      error={error}
      dryrun={dryrun}
      isDisabled={disabled}
      updateInfo={updateInfo}
      close={props.close}
      publish={(onlyPublishLensIds: number[]) => handlePublishScript(false, onlyPublishLensIds)}
      header={`Publish script '${scriptName}'`}
      text={`Publish script '${scriptName}' to the following lenses?`}
    />
  );
};

export default PublishScriptModal;
